<app-multi-select-btn 
    [label]="'Tags'"
    [list]="tags"
    [selected]="selected"
    (onClosed)="closedEvent($event)">
</app-multi-select-btn>
